console.log("Product Filter Loaded");

const PRODUCT_FILTERS = {

    camera: [
        "camera",
        "cctv",
        "security camera",
        "bulb camera",
        "wifi camera",
        "ip camera",
        "ptz",
        "outdoor camera",
        "cc camera",
        "indoor camera"
    ],

    lock: [
        "fingerprint",
        "lock",
        "padlock",
        "door lock"
    ],

    gps: [
        "gps",
        "watch",
        "kids watch",
        "smart watch",
        "tracker"
    ],

    doorbell: [
        "doorbell"
    ],

    smart_bulb: [
        "smart bulb",
        "light"
    ],

    sensor: [
        "sensor",
        "motion sensor",
        "gas sensor",
        "smoke sensor"
    ],

    faucet: [
        "tap",
        "faucet",
        "wash basin",
        "water tap"
    ],

    solar: [
        "solar",
        "solar panel"
    ]

};

function detectRequestedCategory(message){

    message = message.toLowerCase();

    for(const category in PRODUCT_FILTERS){

        const words = PRODUCT_FILTERS[category];

        for(const word of words){

            if(message.includes(word)){
                return category;
            }

        }

    }

    return null;

}